import { useDashboardApiClient } from '@/api/dashboard/useDashboardApiClient'
import type { User } from '@/modules/auth/model'

export const ENDPOINTS = {
    USERS_ME: '/users/me',
    LOGOUT: '/logout',
    REFRESH: '/refresh',
}

export function getUserMe() {
    return useDashboardApiClient<User>({
        url: ENDPOINTS.USERS_ME,
        method: 'GET',
    })
}

export function postLogout() {
    return useDashboardApiClient<{ redirectUrl: string }>({
        url: ENDPOINTS.LOGOUT,
        method: 'POST',
        data: {},
    })
}

export function postRefreshToken() {
    return useDashboardApiClient<void>({
        url: ENDPOINTS.REFRESH,
        method: 'POST',
        data: {},
    })
}
